import { delayApi } from "./delay.api";

export const { useDeleteDelayMutation } = delayApi;
